import { State } from '../../reducers/rootReducer'
import { CarlineId } from '../../../entities/Carline'

const configuredCarlineIdSelector = (state: State): CarlineId => state.configurationData.carlineId

export default configuredCarlineIdSelector
